var _regeneratorRuntime = require("/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/itsasbreuk/Documents/itsawallet/node_modules/@babel/runtime/helpers/asyncToGenerator");

/* eslint max-len: 0 */

/**
 * Common Ethereum tx configuration that enables ethereum-tx to connect to the energi network.
 * Use it together with ethereumjs-tx Transaction.
 *
 * Usage:
 *
 * web3Extension = require('@energi/web3-ext');<br>
 * Tx = require('ethereumjs-tx').Transaction;<br>
 *
 * energiTxCommon = await web3Extension.getTxCommon(web3);<br>
 * tx = new Tx(rawTx, {common: energiCommon});<br>
 *
 *
 * <br>
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module energi-tx-common.js
 * @class getTxCommon
 * @since 0.0.1
*/
// see https://github.com/ethereumjs/ethereumjs-tx/blob/master/examples/custom-chain-tx.ts
var Common = require('ethereumjs-common').default,
    COMMONS = {};
/**
 * Generates common transaction config that can be used by ethereumjs-tx Transaction to
 * make transactions on the Energi Gen3 network.
 *
 * @method getTxCommon
 * @param web3instance {Object} a valid web3 instance, is needed to get the genisis block
 * @return {Promise} resolves with an Object: common transaction configuration for the Energi Gen3 network
 * @since 0.0.1
 */


var getTxCommon = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(web3instance) {
    var network, genesis, chainId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!web3instance || !web3instance.eth || typeof web3instance.extend !== 'function')) {
              _context.next = 2;
              break;
            }

            throw new Error('getTxCommon needs a web3 instance as argument');

          case 2:
            network = web3instance.currentProvider.host;

            if (COMMONS[network]) {
              _context.next = 11;
              break;
            }

            _context.next = 6;
            return web3instance.eth.getBlock(0);

          case 6:
            genesis = _context.sent;
            _context.next = 9;
            return web3instance.eth.getChainId();

          case 9:
            chainId = _context.sent;
            COMMONS[network] = new Common({
              name: 'energi-gen3-network',
              networkId: chainId,
              chainId: chainId,
              url: network,
              genesis: genesis,
              hardforks: [{
                name: 'petersburg',
                block: 0,
                consensus: 'pos',
                finality: null
              }],
              bootstrapNodes: []
            }, 'petersburg');

          case 11:
            return _context.abrupt("return", COMMONS[network]);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getTxCommon(_x) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = getTxCommon;